import { Trans, useTranslation } from 'react-i18next';
import environment from '@environment';
import Checkbox from 'components/inputs/checkbox/checkbox';
import Select from 'components/inputs/select/select';
import { SanitizeHTML } from 'shared/components/html-sanitizer';
import { Util } from 'utils/common.utils';
import styles from './../reward-details-card.module.scss';

function CompetitionDescription({
  details,
  endDate,
  termsAndConditionsLink,
  selectOptions,
  selectVal,
  onSelect,
  onChecked,
  checked,
  disabled,
  label,
}: {
  details?: string;
  endDate: Date;
  termsAndConditionsLink?: { target?: string; name?: string; url?: string };
  selectOptions?: number;
  selectVal?: string;
  onSelect: (val: string) => void;
  onChecked: () => void;
  checked: boolean;
  disabled: boolean;
  label?: string;
}) {
  const { t } = useTranslation();

  const selectOptionsArray = Array.from({ length: selectOptions || 0 }, (_, i) => ({
    value: (i + 1).toString(),
    text: (i + 1).toString(),
  }));

  const handleChange = (val: string) => {
    onSelect(val);
  };

  return (
    <>
      {label ? <img className={styles.rewardLabel} src={Util.GetMediaPath(label)} alt="reward_label" /> : null}
      <div className="text-regular text-dark-60 cust-pt-1 cust-mb-2">
        <SanitizeHTML html={`${details}`} />
      </div>
      <p className="text-small text-dark-60">
        <Trans
          i18nKey="rewards.claim.competition.endDate"
          defaults="Competition end date: {{endDate, datetime}}"
          values={{
            endDate,
            formatParams: {
              endDate: {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              },
            },
          }}
        />
      </p>
      {!disabled ? (
        <>
          <Select
            config={{
              labelText: t('rewards.claim.competition.selectNoOfEntries'),
              placeholderText: t('rewards.claim.competition.select'),
            }}
            value={selectVal}
            options={selectOptionsArray}
            onChange={handleChange}
          />

          {termsAndConditionsLink ? (
            <p className="cust-mt-4 cust-mb-2 text-link text-small">
              <a target={termsAndConditionsLink?.target} href={termsAndConditionsLink?.url}>
                {termsAndConditionsLink?.name === '#'
                  ? t('rewards.claim.competition.termsAndConditions')
                  : termsAndConditionsLink?.name}
              </a>
            </p>
          ) : undefined}

          <div className="cust-mb-4 d-flex align-items-center">
            <Checkbox
              id="enterCompetitionT&C"
              item={{
                id: 'enterCompetitionT&C',
                name: '',
                isChecked: checked,
              }}
              onChange={onChecked}
            />

            <span className="cursor-pointer" onClick={onChecked}>
              <Trans
                i18nKey="agreeTerms"
                values={{ link: termsAndConditionsLink?.url || environment.MULTICHOICE_TERM_AND_CONDITIONS_URL }}
                components={{
                  a: <a target="_blank" onClick={(event) => event.stopPropagation()} />,
                }}
              />
            </span>
          </div>
        </>
      ) : undefined}
    </>
  );
}

export default CompetitionDescription;